import { render } from "./textParamTable.vue?vue&type=template&id=76e4ad06"
import script from "./textParamTable.vue?vue&type=script&lang=js"
export * from "./textParamTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__